// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module__content___n0SPs","saveBtn":"style-module__saveBtn___sVXNr","footer":"style-module__footer___Fn1rw","fakeLink":"style-module__fakeLink___C3lal"};